module.exports = __webpack_public_path__ + "img/ClickForSound_1.8d6af007.png";